export default __webpack_public_path__ + "static/media/unknown.3d30bad1.svg";